module.exports = __webpack_public_path__ + "media/images/single25-3b1aac28cb07395d03977927f7de55e2.jpg";